const ACCOUNT_STATUS_SYNC_KEY = 'sbt_account_status_sync';
const SPACE_STATUS_SYNC_KEY = 'sbt_space_status_sync';

const createEventId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

/** Broadcast an authentication state change to the other same-origin tabs. */
export const notifyAccountStatusChange = (action, accountId = '') => {
  try {
    localStorage.setItem(
      ACCOUNT_STATUS_SYNC_KEY,
      JSON.stringify({
        action,
        accountId: accountId ? String(accountId) : '',
        eventId: createEventId(),
        timestamp: Date.now()
      })
    );
  } catch {
    // Storage can be unavailable in private browsing; authentication still works.
  }
};

export const isAccountStatusDifferent = (rawEvent, currentAccountId) => {
  try {
    const event = JSON.parse(rawEvent);
    if (event.action === 'login' && event.accountId) {
      return String(currentAccountId || '') !== event.accountId;
    }
    return ['logout', 'session-expired'].includes(event.action);
  } catch {
    return false;
  }
};

/** Broadcast a space change to other tabs without sharing credentials. */
export const notifySpaceChange = (accountId, homelandId) => {
  try {
    localStorage.setItem(
      SPACE_STATUS_SYNC_KEY,
      JSON.stringify({
        accountId: accountId ? String(accountId) : '',
        homelandId: homelandId == null ? '' : String(homelandId),
        eventId: createEventId(),
        timestamp: Date.now()
      })
    );
  } catch {
    // Storage can be unavailable in private browsing; space switching still works.
  }
};

export const isSpaceStatusDifferent = (rawEvent, currentAccountId, currentHomelandId) => {
  try {
    const event = JSON.parse(rawEvent);
    if (!event.accountId || !event.homelandId) {
      return false;
    }
    return (
      String(currentAccountId || '') === event.accountId &&
      String(currentHomelandId || '') !== event.homelandId
    );
  } catch {
    return false;
  }
};

export const ACCOUNT_STATUS_SYNC_STORAGE_KEY = ACCOUNT_STATUS_SYNC_KEY;
export const SPACE_STATUS_SYNC_STORAGE_KEY = SPACE_STATUS_SYNC_KEY;
